import  React  from "react";
import PropTypes from 'prop-types';

const Cita = ({ cita, eliminarCita }) => (
	<div className="cita">
		<p>
			Cliente: <span>{cita.cliente}</span>
		</p>
		<p>
			Apellido: <span>{cita.apellido}</span>
		</p>
		<p>
			Fecha: <span>{cita.fecha}</span>
		</p>
		<p>
			Hora: <span>{cita.hora}</span>
		</p>
		<p>
			Detalles: <span>{cita.detalles}</span>
		</p>

		<button
			className="button eliminar u-full-width"
			onClick={() => eliminarCita(cita.id)}
		>
			Eliminar &times;
		</button>
	</div>
);

Cita.propTypes={
	cita:PropTypes.object.isRequired,
	eliminarCita:PropTypes.func.isRequired
}

export default Cita;

